export interface TestimonialType{
    name:string,
    icon:string,
    content:string
}

export const testimonials: TestimonialType[] = [
   // {
   //     name:"adidas",
     //   icon:"/images/brands/social_facebook.png",
      //  content:"You won't reget it. I was amazed at the quality of it. I am really satisfied with my it."
   // }
]

export interface SelectOptionsType{
    name:string,
    value:string
}

export const LeaseTypesOptions: SelectOptionsType[] = [
    {
        name: "New lease",
        value: "New lease"
    },
    {
        name: "Existing lease",
        value: "Existing lease"
    }
]

export const UseClassOptions: SelectOptionsType[] = [
    {
        name:"B2",
        value:"B2",
    },
    {
        name:"B8",
        value:"B8",
    },
    {
        name:"C1",
        value:" C1",
    },
    {
        name:"C2",
        value:"C2",
    },
    {
        name:"C3",
        value:"C3",
    },
    {
        name:"E",
        value:"E",
    },
    {
        name:"E(a)",
        value:"E(a)",
    },
    {
        name:"E(b)",
        value:"E(b)",
    },
    {
        name:"E(c)",
        value:"E(c)",
    },
    {
        name:"E(d)",
        value:"E(d)",
    },
    {
        name:"E(f)",
        value:"E(f)",
    },
    {
        name:"E(g)",
        value:"E(g)",
    },
    {
        name:"F",
        value:"F"
    },
    {
        name:"F1",
        value:"F1"
    },
    {
        name:"F1(a)",
        value:"F1(b)"
    },
    {
        name:"F1(c)",
        value:"F1(c)"
    },
    {
        name:"F1(d)",
        value:"F1(d)"
    },
    {
        name:"F1(e)",
        value:"F1(e)"
    },
    {
        name:"F1(f)",
        value:"F1(f)"
    },
    {
        name: "F2",
        value: "F2"
    },
    {
        name: "F2(a)",
        value: "F2(a)"
    },
    {
        name: "F2(b)",
        value: "F2(b)"
    },
    {
        name: "F2(c)",
        value: "F2(c)"
    },
    {
        name: "F2(d)",
        value: "F2(d)"
    },
    {
        name: "Sui Generis",
        value: "Sui Generis"
    }
]

